export const USED_ACTION_CREATOR = Symbol('USED_ACTION_CREATOR');
